import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
];

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = languages.find((l) => l.code === i18n.language) || languages[0];

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const changeLang = (code) => {
    i18n.changeLanguage(code);
    document.documentElement.setAttribute('lang', code);
    setOpen(false);
  };

  return (
    <div className="lang-switcher" ref={ref}>
      <button
        type="button"
        className="lang-switcher-btn"
        onClick={() => setOpen((o) => !o)}
        aria-label={t('lang.switchTitle')}
        title={t('lang.switchTitle')}
        data-testid="lang-switcher-btn"
      >
        <span className="lang-flag" aria-hidden="true">{current.flag}</span>
      </button>

      {open && (
        <div className="lang-menu" role="menu">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              className={`lang-item ${l.code === current.code ? 'active' : ''}`}
              onClick={() => changeLang(l.code)}
              data-testid={`lang-option-${l.code}`}
              role="menuitemradio"
              aria-checked={l.code === current.code}
            >
              <span className="lang-flag" aria-hidden="true">{l.flag}</span>
              <span className="lang-label">{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
